import { Component } from '@angular/core';
import { AuthService } from "../../services/auth.service";
import { PageTitleService } from "../../services/page-title.service";
import { IonicHelper } from "../../helpers/ionic.helper";
import { User, ViewCanEnter, ViewDidEnter } from "../../app/app.interfaces";
import { NavController, NavParams } from "ionic-angular";
import { FormBuilder, FormGroup } from "@angular/forms";
import { EventService } from "../../services/event.service";
import { ApiService } from "../../services/api.service";
import { UserService } from "../../services/user.service";
import { LoginRequired } from "../../decorators/login.required";

@Component({
  selector: 'edit-profile',
	templateUrl: 'edit-profile.html'
})

@LoginRequired()
export class EditProfile implements ViewDidEnter, ViewCanEnter {

	form: FormGroup;
	showErrors: boolean = false;
	user: User;
	hideSpinner: boolean = false;

	constructor(private formBuilder: FormBuilder,
							public authService: AuthService,
							private apiService: ApiService,
							private nav: NavController,
							private navParams: NavParams,
							private ionic: IonicHelper,
							private pageTitleService: PageTitleService,
							private userService: UserService,
							private eventService: EventService) {
	}

	ionViewCanEnter():  Promise<boolean> {
		
		return new Promise((resolve) => {		
			let userId = this.navParams.get('userId');
			
			this.authService.isLoggedIn().then((loggedIn) => {     
									
				if(!loggedIn) {
					this.nav.setRoot('login');	
					resolve();
				}
				else {
					if((this.authService.user.admin || userId === undefined || (userId !== undefined && this.authService.user.id === parseInt(userId)))){												
						resolve(true);
					}
					else {
						this.nav.setRoot('dashboard');							
						resolve();
					}
				}
			})		
		});
		
	}

	ionViewDidEnter(): void {

		this.pageTitleService.setPageTitle('edit-profile');

		this.getUserForProfile(this.navParams.get('userId')).then((user: User)=>{
			this.user = user;
		},(err) => {			
		  this.hideSpinner = true;
      this.ionic.uncoverableErrorAlert('PROFILE_NOT_FOUND');
		});

	}
	

	getUserForProfile(navParamsUserId: string): Promise<User|string>{
		return new Promise((resolve,reject) =>{
			if(navParamsUserId === undefined || parseInt(navParamsUserId)===this.authService.user.id) {
				this.pageTitleService.setPageTitle('edit-profile');
				resolve(this.authService.user);
			}
			else{
				this.apiService.getResourceById('users', parseInt(navParamsUserId)).then((user: User) => {
					this.pageTitleService.setPageTitle('edit-profile');
					resolve(user);
				}, (err: any) => {					
					reject(err);
				});
			}
		});
	}
}



// WEBPACK FOOTER //
// ./src/components/edit-profile/edit-profile.ts